import React from "react";
import accountContext from "../../../account/accountContext";

const FONT_SORA = "'Sora', system-ui, -apple-system, sans-serif";
const FONT_MONO = "'JetBrains Mono', 'SF Mono', Menlo, Consolas, monospace";

/**
 * Left-hand "Internal Tools" sidebar — placeholder/chrome for the future
 * Internal Tools Portal (§16 forward flag). All rows are placeholders today.
 * The active "Edge Live Monitor" row was removed 2026-05-08 along with the
 * Zone 4 diagnostics footer — page identity is set by the breadcrumb +
 * header in Zone 1, not by a sidebar nav item.
 */
const InternalToolsSidebar: React.FC = () => {
  const placeholderItems = [
    "Catalog Ingestion",
    "Deploy Logs",
    "DB Console",
    "Telemetry Replay",
  ];
  const u = accountContext.user;
  const userLabel = u
    ? [u.firstName, u.lastName].filter(Boolean).join(" ").trim() || u.role
    : undefined;

  return (
    <aside
      style={{
        width: "240px",
        flexShrink: 0,
        // NOTE: full-height "dark left rail" is painted as a left-edge band
        // on the page-root background (see EdgeLiveMonitorPage.tsx
        // PAGE_BG_WITH_RAIL). This aside paints the SAME dark colour over
        // its own children, but the band-on-parent guarantees no light
        // gap appears below the aside's intrinsic content height — robust
        // against flex `align-self: stretch` quirks when the parent uses
        // `min-height: 100vh` and content totals more than 100vh.
        background: "#1A1F1A",
        color: "#E5E2D9",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* brand */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "20px 20px 16px 20px",
        }}
      >
        <div
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: "#D4572B",
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontFamily: FONT_SORA,
            fontSize: "15px",
            fontWeight: 600,
            color: "#FAFAF7",
          }}
        >
          MachineID
        </span>
      </div>

      {/* section header */}
      <div
        style={{
          fontFamily: FONT_MONO,
          fontSize: "10px",
          color: "#7C7E76",
          letterSpacing: "0.1em",
          padding: "12px 20px 8px 20px",
          textTransform: "uppercase",
        }}
      >
        Internal Tools
      </div>

      {/* nav rows */}
      <nav style={{ flex: 1, padding: "0 8px" }}>
        {placeholderItems.map((label) => (
          <div
            key={label}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 12px",
              borderRadius: "4px",
              color: "#7C7E76",
              fontFamily: FONT_SORA,
              fontSize: "13px",
              fontWeight: 400,
              cursor: "default",
              opacity: 0.6,
            }}
          >
            <span style={{ width: "12px", display: "inline-block" }} />
            <span>{label}</span>
          </div>
        ))}
      </nav>

      {/* footer */}
      <div
        style={{
          padding: "16px 20px",
          fontFamily: FONT_MONO,
          fontSize: "10px",
          color: "#7C7E76",
          borderTop: "1px solid #2C322B",
          letterSpacing: "0.04em",
        }}
      >
        <div style={{ marginBottom: "4px" }}>STAFF · ADMIN</div>
        {userLabel && (
          <div style={{ wordBreak: "break-all" }}>{userLabel}</div>
        )}
      </div>
    </aside>
  );
};

export default InternalToolsSidebar;
